<div class="user-table-settings-container no-select">

  <div class="widget-div">

    @if (canEnterNavigationDetailsBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canEnterNavigationDetailsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canEnterNavigationDetailsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Enter Navigation Mode</div>
        </div>
        <div block>
          <div class="form">
            <div class="form-column min-width">
              <div class="form-control-div">
                <div class="option-title">
                  <label for="enterSelection">{{ text.settings.userTableSetting.enterSelection }}</label>
                  <app-display-icon
                    [tooltip]="ngpPreviewColumnsConstants.optionTip"
                    [icon]="icons.infoSlabCircleOutline"
                    [colour]="iconColours.secondary">
                  </app-display-icon>
                </div>

                <app-shared-custom-select
                  id="enterSelection"
                  (selectionChange)="onChangeEnterNavigationOption($event)"
                  [allowMultiple]="false"
                  [placeholder]="'Select Setting...'"
                  [selected]="selectedEnterNav"
                  [setOptions]="navigationOptions('enter')"
                  [showChips]="false">
                </app-shared-custom-select>
              </div>
            </div>

          </div>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasEnterNavigationDetailsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canEnterNavigationDetailsBeEdited === false"
              (click)="onRevertForm('enter')">
              <app-display-icon
                [colour]="canEnterNavigationDetailsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canEnterNavigationDetailsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isEnterNavigationDetailsSubmitDisabled"
              (click)="onSubmitForm('enter')">
              <app-display-icon
                [colour]="isEnterNavigationDetailsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

    @if (canTabNavigationDetailsBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canTabNavigationDetailsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canTabNavigationDetailsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Tab Navigation Mode</div>
        </div>
        <div block>
          <div class="form">

            <div class="form-column min-width">
              <div class="form-control-div">
                <div class="option-title">
                  <label for="enterSelection">{{ text.settings.userTableSetting.tabSelection }}</label>
                  <app-display-icon
                    [tooltip]="ngpPreviewColumnsConstants.optionTip"
                    [icon]="icons.infoSlabCircleOutline"
                    [colour]="iconColours.secondary">
                  </app-display-icon>
                </div>
                <app-shared-custom-select
                  (selectionChange)="onChangeTabNavigationOption($event)"
                  [allowMultiple]="false"
                  [placeholder]="'Select Setting...'"
                  [selected]="selectedTabNav"
                  [setOptions]="navigationOptions('tab')"
                  [showChips]="false">
                </app-shared-custom-select>
              </div>
            </div>

          </div>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasTabNavigationDetailsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canTabNavigationDetailsBeEdited === false"
              (click)="onRevertForm('tab')">
              <app-display-icon
                [colour]="canTabNavigationDetailsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canTabNavigationDetailsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isTabNavigationDetailsSubmitDisabled"
              (click)="onSubmitForm('tab')">
              <app-display-icon
                [colour]="isTabNavigationDetailsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }
    @if (canNGPColumnsDetailsBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canNGPColumnsDetailsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canNGPColumnsDetailsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>NGP Columns</div>
        </div>
        <div block>
          <div class="form">
            <div class="form-column min-width">
              <div class="form-control-div">
                <div class="option-wrapper">
                  <div class="option-title">
                    <label for="enterSelection">
                      {{ ngpPreviewColumnsConstants.title }}
                    </label>
                    <app-display-icon
                      [tooltip]="ngpPreviewColumnsConstants.optionTip"
                      [icon]="icons.infoSlabCircleOutline"
                      [colour]="iconColours.secondary">
                    </app-display-icon>
                  </div>
                  <div class="option-content chips-container">
                    <app-shared-custom-select
                      id="ngpPreviewColumns"
                      [allowMultiple]="true"
                      [allowSelectAll]="true"
                      [placeholder]="'Select preview columns...'"
                      [searchPlaceholder]="'Search columns...'"
                      [selected]="ngpPreviewSelectedKeys"
                      [setOptions]="ngpPreviewOptions"
                      [showChips]="false"
                      [showSearchBar]="true"
                      (selectionChange)="onNgpPreviewChange($event)">
                    </app-shared-custom-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasNGPColumnsDetailsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canNGPColumnsDetailsBeEdited === false"
              (click)="onRevertForm('ngp')">
              <app-display-icon
                [colour]="canNGPColumnsDetailsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canNGPColumnsDetailsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isNGPColumnsDetailsSubmitDisabled"
              (click)="onSubmitForm('ngp')">
              <app-display-icon
                [colour]="isNGPColumnsDetailsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

    @if (canStockColumnsDetailsBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canStockColumnsDetailsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canStockColumnsDetailsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Stock Management Columns</div>
        </div>
        <div block>
          <div class="form">
            <div class="form-column min-width">
              <div class="form-control-div">
                <div class="option-wrapper">
                  <div class="option-title">
                    <label>
                      {{ stockManagerPreviewColumnsConstants.title }}
                    </label>
                    <app-display-icon
                      [tooltip]="stockManagerPreviewColumnsConstants.optionTip"
                      [icon]="icons.infoSlabCircleOutline"
                      [colour]="iconColours.secondary">
                    </app-display-icon>
                  </div>
                  <div class="option-content chips-container">
                    <app-shared-custom-select
                      id="stockPreviewColumns"
                      [allowMultiple]="true"
                      [allowSelectAll]="true"
                      [placeholder]="'Select preview columns...'"
                      [searchPlaceholder]="'Search columns...'"
                      [selected]="stockManagerPreviewSelectedKeys"
                      [setOptions]="stockManagerPreviewOptions"
                      [showChips]="false"
                      [showSearchBar]="true"
                      (selectionChange)="onStockManagerPreviewChange($event)">
                    </app-shared-custom-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasStockPreviewBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canStockColumnsDetailsBeEdited === false"
              (click)="onRevertForm('stock')">
              <app-display-icon
                [colour]="canStockColumnsDetailsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canStockColumnsDetailsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isStockColumnsDetailsSubmitDisabled"
              (click)="onSubmitForm('stock')">
              <app-display-icon
                [colour]="isStockColumnsDetailsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
